@if (sortedTableValues$ | async; as view) {
    @if (view.noDataFromApi) {
        <div class="alert alert-warning text-center m-3" role="alert">
            {{
                ('table_NO_DATA_FROM_SOURCE' | translate: 'online' : 'common')
                    .replace('{0}', 'monitoring_Variable-alarms' | translate)
                    .replace('{1}', 'monitoring_create-variable-alarm' | translate)
            }}
        </div>
    } @else {
        <div class="table-responsive w-100">
            <table class="table table-striped table-sm">
                <thead>
                    <tr>
                        @for (head of columnHeads; track $index) {
                            <th
                                app-sortable-table-header
                                [column]="head.column"
                                (sort)="onSort($event)"
                                [label]="head.label"></th>
                        }
                        <th class="last-col"></th>
                    </tr>
                    <tr [formGroup]="formGroupFilter">
                        @for (head of columnHeads; track $index) {
                            <th class="align-top">
                                @if (head.formType === 'text') {
                                    <app-input-text-group
                                        [formControl]="head.formControl"></app-input-text-group>
                                }
                                @if (head.formType === 'selectMultiple') {
                                    <app-input-dropdown-checkboxes [formControl]="head.formControl">
                                    </app-input-dropdown-checkboxes>
                                }
                            </th>
                        }
                        <th></th>
                    </tr>
                </thead>
                <tbody class="text-nowrap">
                    @for (variableAlarm of view.variableAlarms; track $index) {
                        <tr>
                            <td class="text-center">
                                @if (variableAlarm.meterCriteriaMismatch) {
                                    <i class="bi bi-exclamation-circle-fill text-warning"></i>
                                } @else {
                                    <i class="bi bi-check-circle-fill text-success"></i>
                                }
                            </td>
                            <td>
                                {{ variableAlarm.alarmName }}
                            </td>
                            <td>
                                {{ variableAlarm.usageTranslated }}
                            </td>
                            <td>
                                {{ variableAlarm.unitTranslated }}
                            </td>
                            <td style="width: 30px" class="last-col">
                                <div ngbDropdown placement="bottom-right" container="body">
                                    <button
                                        class="btn btn-link btn-sm"
                                        id="dropdownMeterActions"
                                        ngbDropdownToggle
                                        style="float: right">
                                        <i class="bi bi-three-dots-vertical"></i>
                                    </button>
                                    <div ngbDropdownMenu>
                                        <button
                                            ngbDropdownItem
                                            (click)="
                                                editAlarm.emit(variableAlarm.deviationNotificRuleId)
                                            ">
                                            {{ 'common_Edit' | translate }}
                                        </button>
                                        <button
                                            ngbDropdownItem
                                            (click)="duplicateAlarm.emit(variableAlarm)">
                                            {{ 'monitoring_duplicate' | translate }}
                                        </button>
                                        <button
                                            ngbDropdownItem
                                            (click)="deleteVariableAlarm.emit(variableAlarm)">
                                            {{ 'common_Delete' | translate }}
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    } @empty {
                        <tr>
                            <td colspan="20" class="text-center">
                                {{ 'table_noResults' | translate: 'online' : 'common' }}
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
        <div class="text-center">
            <app-pagination
                [collectionSize]="view.collectionSize"
                [page]="view.page"
                (pageChange)="setPage($event)"
                (pageSizeChange)="setPageSize($event)"></app-pagination>
        </div>
    }
} @else {
    <app-load />
}
